var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticStyle:{"color":"white"},attrs:{"to":'/m-student-fee'}},[_c('div',{staticClass:"statement-content"},[_c('div',[_c('img',{attrs:{"src":"https://img.icons8.com/color/120/000000/money.png","alt":""}}),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.info))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }